
import React, {useState} from 'react';
import styles from  './MySpace.module.css';
import EmailForm from '../components/EmailForm'; 
import LimitedAdvise from '../components/LimitedAdvise'; 
import FollowStrategyManager from '../components/FollowStrategyManager';
import { useSelector } from 'react-redux';

function MySpace() { 
    const [activeTab, setActiveTab] = useState(0);
    const { isPremium } = useSelector(state => state.globalData);

    const renderContent = () => {
      switch (activeTab) {
        case 0:
          return <EmailForm/>;
        case 1:
          return <FollowStrategyManager/>;        
        default:
          return null;
      }
    };

    return (
        <>
        

        <div className={styles.main_page}>
            <header className={styles.main_header}>
                <h1>My Space</h1>
            </header>            
            <main>
                <section className={styles.content} style={{display:'flex', flexDirection:'column', alignItems:'center'}}>
                {!isPremium && (          
                    <><div style={{ position: 'absolute', right: '8%' }}>
                            <LimitedAdvise
                                width="80px"
                                height="20px"
                                message="Limited"
                                tooltipTitle="Why it's limited?"
                                tooltipPhrases={["Notifications unavailable"]}
                                tooltipPosition="left" // Options: top, down, left, right
                                tooltipWidth="250px" />
                        </div><br /><br /></>                
                )}
                    {/* <div style={{ width: "100%", margin: "20px auto", textAlign: "center" }}> */}
                        {/* Tab Navigation */}
                        <div style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}>
                            <button
                            onClick={() => setActiveTab(0)}
                            style={{background: activeTab === 0 ? "#465b94" : "#131722"}}
                            className={styles.tabs}
                            >
                            Email Setting
                            </button>
                            <button
                            onClick={() => setActiveTab(1)}
                            style={{background: activeTab === 1 ? "#465b94" : "#131722"}}
                            className={styles.tabs}
                            >
                            Strategy Watchlist
                            </button>                           
                        </div>

                        {/* Tab Content */}
                        {renderContent()}
                    {/* </div> */}
                </section>
            </main>                     
        </div></>
    );
}

export default MySpace;



  






